import { createApp } from 'vue';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';
import axios from "axios";
import 'normalize.css';
import './assets/css/base.css';
import elementIcon from "./plugins/icons";
import ElementPlus from 'element-plus';
import zhCn from 'element-plus/es/locale/lang/zh-cn';
import echarts from './plugins/echarts';
import qs from 'qs';
// 引入自定义图标组件
import '@/assets/iconfont'
import SvgIcon from '@/components/SvgIcon/index.vue';
// 导入接口---挂全局---
import api from '@/api';
import expandApi from '@/api/expand';
import loginApi from '@/api/login';
import itemApi from '@/api/item';
import orderApi from '@/api/order';
import homeApi from '@/api/home';
import bsnsApi from '@/api/bsns';
import financeApi from '@/api/finance';
import deliveryApi from '@/api/delivery';
//路由守卫，当页面没有登录就跳转登录页面
import '@/router/permission';
//用户验证按钮
import { myFunc } from './sys/mixinFunc';

const app = createApp(App);

app.use(store);
app.use(router);
app.use(elementIcon);
app.use(ElementPlus, { locale: zhCn });
app.config.globalProperties.$http = axios;
app.provide('$echarts', echarts);
app.provide('$api', {
    ...api,
    ...expandApi,
    ...loginApi,
    ...itemApi,
    ...orderApi,
    ...homeApi,
    ...bsnsApi,
    ...financeApi,
    ...deliveryApi
});
app.config.globalProperties.$qs = qs;
app.component('SvgIcon', SvgIcon);
app.mixin(myFunc);

// 引入 iconfont 图标（确保这是您的 iconfont 项目的正确 URL）
const iconUrl = '//at.alicdn.com/t/xxx.js' // 替换成您的 iconfont 项目 URL
const script = document.createElement('script')
script.src = iconUrl
document.body.appendChild(script)

// 直接重写 console.error 来过滤掉 ResizeObserver 警告
const originalError = console.error;
console.error = (...args) => {
    if (
        args[0] &&
        typeof args[0] === 'string' &&
        args[0].includes('ResizeObserver')
    ) {
        return;
    }
    originalError.apply(console, args);
};

app.mount("#app");